<script>
import StoreButton from '@/components/app/shared/StoreButton'
import Fade from '@/components/transitions/Fade'
import FadeSlideUp from '@/components/transitions/FadeSlideUp'
import { storeButtons } from '@/data/app'

export default {
  components: { StoreButton, Fade, FadeSlideUp },
  data() {
		return {
			storeButtons,
		}
	},
}
</script>

<template>
	<section class="py-10 px-6 flex flex-col max-w-md">
		<FadeSlideUp>
			<h2
				class="mt-1 self-center font-header font-medium text-grey-700 text-center leading-tight uppercase text-pretty"
				style="font-size: 32px; letter-spacing: 3.36px;"
			>Connect, share and fly smarter.</h2>
		</FadeSlideUp>
		<div
			class="relative"
			style="margin-top: 71px;"
		>
			<Fade>
				<div
					class="absolute inset-0 border"
					style="
						border-radius: 16px;
						background: rgba(179, 159, 159, 0.20);
						border-color: rgba(255, 255, 255, 0.6);
					"
				/>
			</Fade>
			<FadeSlideUp>
				<div class="relative p-6 flex flex-col">
					<img
						src="/assets/img/app/devices.webp"
						alt="Devices running the Jetfly Owner Mobile App"
						width="246"
						height="298"
						class="self-center -mt-16"
					/>
					<div class="mt-10 flex flex-col gap-5">
						<StoreButton
							v-for="storeButton in storeButtons"
							:key="storeButton.key"
							:url="storeButton.url"
							:name="storeButton.name"
							:icon="storeButton.icon"
							:qrSrc="storeButton.qrSrc"
						/>
					</div>
				</div>
			</FadeSlideUp>
		</div>
	</section>
</template>
